export const restApi: String = 'https://partobo.ru:8000'